import { Text, Title, type UseModalState } from "@clipboard-health/ui-react";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import { Button, Stack } from "@mui/material";
import { NotificationDialog } from "@src/appV2/lib";
import { HOT_SHIFT_ORANGE } from "@src/appV2/lib/Theme/constants";

interface HotShiftDialogProps {
  modalState: UseModalState;
}

export function HotShiftDialog(props: HotShiftDialogProps) {
  const { modalState } = props;

  return (
    <NotificationDialog
      aria-labelledby="hot-shift-dialog-title"
      modalState={modalState}
      title={
        <Stack alignItems="center" justifyContent="center" direction="row">
          <LocalFireDepartmentIcon sx={{ color: HOT_SHIFT_ORANGE }} />
          <Title id="hot-shift-dialog-title" sx={{ color: HOT_SHIFT_ORANGE }} component="h2">
            Hot Shift
          </Title>
        </Stack>
      }
    >
      <Stack spacing={1.5}>
        <Text align="center">
          We&apos;re temporarily offering higher pay in this area to meet demand.
        </Text>
        <Text paddingBottom={1.5} align="center">
          Similar shifts in the area will likely pay less in the future.
        </Text>
        <Button
          variant="contained"
          onClick={() => {
            modalState.closeModal();
          }}
        >
          OK
        </Button>
      </Stack>
    </NotificationDialog>
  );
}
